import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from './components/header/header.component';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FederationShellComponent } from './components/federation-shell/federation-shell.component';
import { NoFederationComponent } from './components/no-federation/no-federation.component';
import { InvalidFederationComponent } from './components/invalid-federation/invalid-federation.component';
import { JustificatifComponent } from './components/justificatif/justificatif.component';
import { ColonnesComponent } from './components/charts/colonnes.component';
import { BarresHComponent } from './components/charts/barres-h.component';
import { AnneauComponent } from './components/charts/anneau.component';
import { CourbeComponent } from './components/charts/courbe.component';

@NgModule({
  declarations: [
    HeaderComponent,
    MainLayoutComponent,
    SidebarComponent,
    FederationShellComponent,
    NoFederationComponent,
    InvalidFederationComponent,
    JustificatifComponent,
    ColonnesComponent,
    BarresHComponent,
    AnneauComponent,
    CourbeComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    HeaderComponent,
    MainLayoutComponent,
    SidebarComponent,
    FederationShellComponent,
    NoFederationComponent,
    InvalidFederationComponent,
    JustificatifComponent,
    ColonnesComponent,
    BarresHComponent,
    AnneauComponent,
    CourbeComponent,
  ]
})
export class SharedModule {}
